import React from 'react';
import { Col, Row, Label } from 'reactstrap';
import * as PropTypes from 'prop-types';
import {
  FormSelectField,
  FormInputField,
  FormCheckboxField,
} from '../../../common/components/formFields';
import { DealerPendingActionTypes } from '../../../constants/DealerPendingActionTypes';
import PendingActionButtons from '../PendingActionButtons';
import { constantToSelect } from '../../../common/helpers';
import { UserPositionName } from '../../../constants/UserPosition';

const dealerUserPositions = constantToSelect(UserPositionName);

function DealerUserForm({ disabled, preparePendingActionObj, errors }) {
  const phoneNumberDataObj = preparePendingActionObj(
    DealerPendingActionTypes.PHONE_NUMBER_CHANGE,
  );

  const landlinePhoneNumberDataObj = preparePendingActionObj(
    DealerPendingActionTypes.LANDLINE_PHONE_NUMBER_CHANGE,
  );

  const errorRole = errors?.isBuyer ? errors?.isBuyer : errors?.isSeller || '';

  return (
    <>
      <h4 className="mt-4 mb-3 fw-bold">Dealer details</h4>
      <Row>
        <Col md="4">
          <FormInputField name="firstName" label="First Name" disabled={disabled} required />
        </Col>
        <Col md="4">
          <FormInputField name="lastName" label="Last Name" disabled={disabled} required />
        </Col>
        <Col md="4">
          <FormInputField name="email" label="Email" disabled={disabled} required />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormInputField
            name="landlinePhoneNumber"
            label="Landline Phone Number"
            disabled={disabled}
          />
          <PendingActionButtons
            data={landlinePhoneNumberDataObj}
            type={DealerPendingActionTypes.LANDLINE_PHONE_NUMBER_CHANGE}
          />
        </Col>
        <Col md="4">
          <FormInputField
            name="phoneNumber"
            label="Mobile Phone Number"
            disabled={disabled}
            required
          />
          <PendingActionButtons
            data={phoneNumberDataObj}
            type={DealerPendingActionTypes.PHONE_NUMBER_CHANGE}
          />
        </Col>
        <Col md="4">
          <FormSelectField
            name="position"
            label="Position"
            options={dealerUserPositions}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <Label className="label-required">Role</Label>
          <div className="d-flex flex-column gap-2">
            <FormCheckboxField
              invalid={false}
              label="Buyer"
              name="isBuyer"
              disabled={disabled}
            />
            <FormCheckboxField
              invalid={false}
              label="Seller"
              name="isSeller"
              disabled={disabled}
            />
          </div>
          <p
            style={{
              color: 'red',
              fontSize: 13,
              fontWeight: 400,
              marginTop: 8,
              letterSpacing: '0.02em',
            }}
          >
            {errorRole}
          </p>
        </Col>
      </Row>
    </>
  );
}
DealerUserForm.defaultProps = {
  disabled: false,
};

DealerUserForm.propTypes = {
  preparePendingActionObj: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.object.isRequired,
};

export default DealerUserForm;
